import MemberList from '@/pages/voucher-selling/member-list/routes'
import VoucherSellingList from '@/pages/voucher-selling/voucher-selling-list/routes'
import ManualBurnList from '@/pages/voucher-selling/manual-burn-list/routes'

export default {
  path: 'voucher-selling',
  component: () => import('@/components/layouts/ChildLayout.vue'),
  children: [...MemberList, ...VoucherSellingList, ...ManualBurnList]
}
